/**
 * Splits a location string into its constituent parts, such as city and display name.
 * Handles optional postal codes and country information.
 *
 * @param {string} input - The location string to split. It should be in the format "city, country" or
 *        optionally have a postal code prefixed (e.g., "12345 City, Country").
 * @return {{ city: string, display: string }} An object containing the extracted city name and a formatted display string.
 *
 * @example
 * // Example usage:
 * const result = splitLocation("12345 New York, USA");
 * // result = { city: "New York", display: "New York (12345), USA" }
 *
 * const result2 = splitLocation("Paris, France");
 * // result2 = { city: "Paris", display: "Paris, France" }
 *
 * const result3 = splitLocation("Tokyo");
 * // result3 = { city: "Tokyo", display: "Tokyo" }
 */
export function splitLocation(input: string): { city: string; display: string } {
  const [left = '', countryRaw] = input.trim().split(','); // défaut pour éviter TS18048
  const country = countryRaw?.trim();
  const leftPart = left.trim();

  const m = leftPart.match(/^(\d{3,10})\s+(.+)$/u);
  const postal = m?.[1];
  const city = m?.[2] ?? leftPart;

  const display = postal
    ? `${city} (${postal})${country ? `, ${country}` : ''}`
    : `${city}${country ? `, ${country}` : ''}`;

  return { city, display };
}
